import React, { useState, useEffect } from "react";

const ThumbnailComponent = ({ imageUrl, reportTitle, imageCount, size = 80 }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    if (imageUrl) {
      setLoading(true);
      setError(false);
      
      // Preload the image
      const img = new Image();
      img.onload = () => {
        setImageSrc(imageUrl);
        setLoading(false);
      };
      img.onerror = () => {
        setError(true);
        setLoading(false);
      };
      img.src = imageUrl;
    } else {
      setLoading(false);
    }
  }, [imageUrl]);

  const containerStyle = {
    width: `${size}px`,
    height: `${size}px`,
    flexShrink: 0,
    border: "2px solid #ddd",
    borderRadius: "8px",
    overflow: "hidden",
    backgroundColor: "#f8f9fa",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative"
  };

  const loadingStyle = {
    color: "#666",
    fontSize: "10px",
    textAlign: "center",
    animation: "pulse 1.5s ease-in-out infinite"
  };

  const noImageStyle = {
    color: "#666",
    fontSize: size > 60 ? "12px" : "10px",
    textAlign: "center",
    padding: "5px",
    lineHeight: "1.2"
  };

  const imageStyle = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transition: "transform 0.2s ease"
  };

  const overlayStyle = {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    background: "linear-gradient(to top, rgba(0,0,0,0.7), transparent)",
    color: "white",
    fontSize: "9px",
    padding: "2px 4px",
    textAlign: "center"
  };

  // Loading state
  if (loading) {
    return (
      <div style={containerStyle}>
        <div style={loadingStyle}>
          🔄<br/>Loading...
        </div>
      </div>
    );
  }

  // Error state or no image
  if (error || !imageUrl || !imageSrc) {
    return (
      <div style={containerStyle}>
        <div style={noImageStyle}>
          {imageCount > 0 ? (
            <>
              📷<br/>
              {imageCount}<br/>
              {imageCount === 1 ? 'Image' : 'Images'}
            </>
          ) : (
            <>
              📄<br/>
              No<br/>
              Images
            </>
          )}
        </div>
      </div>
    );
  }

  // Success state with image
  return (
    <div 
      style={containerStyle}
      onMouseEnter={(e) => {
        const img = e.currentTarget.querySelector('img');
        if (img) img.style.transform = "scale(1.05)";
      }}
      onMouseLeave={(e) => {
        const img = e.currentTarget.querySelector('img');
        if (img) img.style.transform = "scale(1)";
      }}
    >
      <img
        src={imageSrc}
        alt={`Thumbnail for ${reportTitle}`}
        style={imageStyle}
      />
      {imageCount > 1 && (
        <div style={overlayStyle}>
          +{imageCount - 1} more
        </div>
      )}
    </div>
  );
};

export default ThumbnailComponent;

